import React from "react";

const ErrorMessage = ({message}) => {
  return (
      <>
        {
            message && <small className="text-danger d-block text-left mt-1">
              <i className="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
              {message}
            </small>
        }
      </>

  );
};

export default ErrorMessage;
